import { vtObjToFormData, vtObjToQueryString } from '@app/helpers/objHelper';
import { convertToSlug } from '@app/helpers/stringHelper';
import api from './api';

const controller = 'fornecedores';

export interface Fornecedor {
  id: string;
  cnpj?: string;
  nome?: string;
  nomeResumido?: string;
  numero?: string;
}

export const getAllFornecedor = (page?: number) => api.get<Fornecedor[]>(`${controller}?page=${page}`);

export const getFornecedoresByTerm = (term: string) =>
  api
    .get<Fornecedor[]>(`${controller}?searchTerm=${encodeURIComponent(term)}`)
    .then((fornecedores) =>
      (fornecedores || []).map((item) => ({
        text: `${item.numero || ''} - ${item.nome || item.nomeResumido}`,
        value: item.id.toString(),
      })),
    );

export const getAllFornecedoresOptions = (page?: number) =>
  getAllFornecedor(page)
    .then(fornecedor =>
      (fornecedor || []).map(item => ({ text: item.nome, value: item.id.toString() })),
    );

export const getAllFornecedoresOptionsWithNomeValue = (page?: number) =>
  getAllFornecedor(page)
    .then(fornecedor =>
      (fornecedor || []).map(item => ({ text: item.nome, value: item.nome })),
    );

export const getByCnpjOuCodigo = (filtro: any) =>
  api.get<Fornecedor>(`${controller}/getByCnpjOuCodigo?${vtObjToQueryString(filtro)}`);

export const getByCnpj = (cnpj: string, ocId: string) =>
  api.get<Fornecedor>(`${controller}/getByCnpj/${cnpj}/${ocId}`);

export const getByCodigo = (codigo: string, ocId: string) =>
  api.get<Fornecedor>(`${controller}/getByCodigo/${codigo}/${ocId}`);
